
import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useAuthState } from 'react-firebase-hooks/auth';
import { getFirebaseAuth } from '@/lib/firebase';
import { AppProvider, useApp } from '@/context/AppContext';

import AuthScreen from './screens/AuthScreen';
import MainScreen from './screens/MainScreen';

const AppContent: React.FC = () => {
  const auth = getFirebaseAuth();
  const [user, loading] = useAuthState(auth);
  const { loadInitialState, isLoaded, setAppAsLoaded } = useApp();

  useEffect(() => {
    if (user && !isLoaded) {
      loadInitialState();
    } else if (!user && !loading) {
      // If there's no user, we can mark the app as "loaded" with the default state.
      setAppAsLoaded();
    }
  }, [user, isLoaded, loading, loadInitialState, setAppAsLoaded]);

  if (loading || !isLoaded) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-slate-100 dark:bg-slate-900">
        <div className="text-xl font-semibold text-slate-700 dark:text-slate-300">Loading...</div>
      </div>
    );
  }
  
  return (
    <Router>
      <Routes>
        <Route path="/auth" element={!user ? <AuthScreen /> : <Navigate to="/" />} />
        <Route path="/" element={user ? <MainScreen /> : <Navigate to="/auth" />} />
      </Routes>
    </Router>
  );
}

const App: React.FC = () => {
  return (
    <AppProvider>
      <AppContent />
    </AppProvider>
  );
};

export default App;
